import React from "react";
import { useDispatch } from "react-redux";
import { Button, TextField, Grid, Typography, Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import AuthPage from "./AuthPage";
import ErrorBox from "components/utils/ErrorBox";
import { ROUTES } from "routes";
import { useAuthState } from "hooks";
import { useForm } from "hooks/forms";
import { RESET_PASSWORD_STATE } from "constants/status";
import { reset_password } from "actions/auth";

const useStyles = makeStyles((theme) => ({
  infoBox: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
  alert: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function RequestResetPassword() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { loading, errors, success } = useAuthState(RESET_PASSWORD_STATE);
  const { values, touched, handleUserInput, handleSubmit } = useForm(
    {
      email: "",
    },
    ({ email }) => dispatch(reset_password(email))
  );

  const beforeBox = (
    <div className={classes.infoBox}>
      <Typography className={classes.alert} align="justify">
        Indiquez l'adresse du compte dont le mot de passe doit être
        réinitialisé.
      </Typography>
    </div>
  );

  const successBox = (
    <div className={classes.infoBox}>
      <Typography className={classes.alert} align="justify">
        Nous vous avons envoyé un e-mail de confirmation à l'adresse{" "}
        {values.email}. Cliquez sur le lien fourni dans l'e-mail pour changer
        votre mot de passe.
      </Typography>
      <Typography className={classes.alert} align="justify">
        Vérifiez votre dossier "Spam". Si vous ne le recevez pas d'ici quelques
        minutes, rafraîchissez cette page pour demander un nouvel e-mail.
      </Typography>
    </div>
  );

  return (
    <AuthPage loading={loading} title="Réinitialiser le mot de passe">
      {success && successBox}
      <ErrorBox errorDict={errors} />
      {!success && beforeBox}
      {!success && (
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Adresse e-mail"
            name="email"
            autoComplete="email"
            autoFocus
            value={values.email}
            error={Boolean(errors.email) && !touched.email}
            helperText={!touched.email && errors.email}
            onChange={handleUserInput}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Réinitialiser
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link
                component={RouterLink}
                to={ROUTES.login.path}
                variant="body2"
              >
                Se connecter
              </Link>
            </Grid>
          </Grid>
        </form>
      )}
    </AuthPage>
  );
}
